import { AppSectionTitle } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { createFileRoute } from '@tanstack/react-router'
import { Alerts } from './-components/Alerts'
import { CreateOpportunitySummaryChart } from './-components/CreateOpportunitySummaryChart'
import { OpportunitySalesSummaryChart } from './-components/OpportunitySalesSummaryChart'
import { SharableOpportunityCarousel } from './-components/SharableOpportunityCarousel'
import { ShiftServicesSection } from './-components/ShiftServicesSection'
import { SupportLinksSection } from './-components/SupportLinksSection'

export const Route = createFileRoute('/_authenticated/opportunities/')({
  component: OpportunitiesHomePage,
})

function OpportunitiesHomePage() {
  return (
    <div className='grid h-full grid-rows-[auto_minmax(0,1fr)]'>
      <AppSectionTitle>Home</AppSectionTitle>
      <div className='h-full min-h-0 p-8 space-y-6 overflow-auto'>
        <Alerts />

        <SharableOpportunityCarousel />

        <SupportLinksSection />

        <div className='space-y-4'>
          <h3 className='text-lg font-semibold'>ウィジェット</h3>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <CreateOpportunitySummaryChart />
            <OpportunitySalesSummaryChart />
          </div>
        </div>

        <ShiftServicesSection />
      </div>
    </div>
  )
}
